var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-aside-slide',{staticClass:"main-page-image-aside-slide",attrs:{"image-src":_vm.image.image,"image-alt":_vm.image.alt_text,"preferred-image-position":_vm.preferredImagePosition}},[_c('main-text-block',{attrs:{"title":_vm.image.title,"text":_vm.image.description}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7377a30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-content/MainSlideImageAside.vue
// module id = null
// module chunks = 